import { render, staticRenderFns } from "./list_reports_component.vue?vue&type=template&id=1f5bb7dc&scoped=true"
import script from "./list_reports_component.vue?vue&type=script&lang=js"
export * from "./list_reports_component.vue?vue&type=script&lang=js"
import style0 from "./list_reports_component.vue?vue&type=style&index=0&id=1f5bb7dc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5bb7dc",
  null
  
)

export default component.exports